import { Button, Card, Col, Divider, Layout, Row, Typography } from "antd";
import React from 'react';

const ChatIframe = () => {
    return (
        <iframe
            src="https://assistant.totum.surgery/"
            title="Assistant"
            style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                border: 'none',
                overflow: 'hidden',
            }}
        ></iframe>
    );
};

export default ChatIframe;